import { last, mapKeys } from "lodash-es";

const flattenObjectKeys = (object) =>
  mapKeys(object, (_, key) => last(key.split(".")));

export { flattenObjectKeys };
